import { defineMessages } from 'react-intl';

const messages = defineMessages({
  rateContentTitle: {
    id: 'LessonReviewModal.rateContentTitle',
    defaultMessage: 'Rate this content',
  },
  rateContentHeading: {
    id: 'LessonReviewModal.rateContentHeading',
    defaultMessage:
      'Help improve the learning experience by giving your opinion.',
  },
  interestingQuestion: {
    id: 'LessonReviewModal.interestingQuestion',
    defaultMessage: 'Was this interesting?',
  },
  challengingQuestion: {
    id: 'LessonReviewModal.challengingQuestion',
    defaultMessage: 'How challenging was this?',
  },
  competentQuestion: {
    id: 'LessonReviewModal.competentQuestion',
    defaultMessage: 'How competent did you feel?',
  },
  submitRatingLabel: {
    id: 'LessonReviewModal.submitRatingLabel',
    defaultMessage: 'Submit rating',
  },
  updateRatingLabel: {
    id: 'LessonReviewModal.updateRatingLabel',
    defaultMessage: 'Update rating',
  },
  easyLabel: {
    id: 'LessonReviewModal.easyLabel',
    defaultMessage: 'Easy',
  },
  difficultLabel: {
    id: 'LessonReviewModal.difficultLabel',
    defaultMessage: 'Difficult',
  },
  noviceLabel: {
    id: 'LessonReviewModal.noviceLabel',
    defaultMessage: 'Novice',
  },
  expertLabel: {
    id: 'LessonReviewModal.expertLabel',
    defaultMessage: 'Expert',
  },
  noLabel: {
    id: 'General.noLabel',
    defaultMessage: 'No',
  },
  yesLabel: {
    id: 'General.yesLabel',
    defaultMessage: 'Yes',
  },
  leaveRatingSuccess: {
    id: 'LessonReviewModal.leaveRatingSuccess',
    defaultMessage: 'Thank you for rating the content!',
  },
});

export default messages;
